import { AxiosPromise } from 'axios';
import { IGetMenu, IGetMenus, IMenuReq, IMenuSeqReq } from '../models/menus.model';
import axios from 'axios';

const uri = '/mgmt/menus';

export const getMenu = (id: number): AxiosPromise<IGetMenu> => {
  return axios.get(`${uri}/${id}`);
}

export const getMenus = (): AxiosPromise<IGetMenus> => {
  return axios.get(`${uri}/list`);
}

export const getSubmenus = (id: number): AxiosPromise<IGetMenus> => {
  return axios.get(`${uri}/list/${id}`);
}

export const createMenu = (data: IMenuReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const createSubmenu = (id: number, data: IMenuReq): AxiosPromise => {
  return axios.post(`${uri}/${id}`, data);
};

export const updateMenu = (id: number, data: IMenuReq): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const updateMenuSeq = (data: IMenuSeqReq[]): AxiosPromise => {
  return axios.put(`${uri}/sequence`, data);
};

export const updateSubmenuSeq = (id: number, data: IMenuSeqReq[]): AxiosPromise => {
  return axios.put(`${uri}/${id}/sequence`, data);
};

export const deleteMenu = (menuCode: number): AxiosPromise => {
  return axios.put(`${uri}/remove/${menuCode}`);
};
